<template>
    <div>
        <a-modal :title="$t('resolved.title')" :width="650" :visible="visible" @cancel="handleCancel" :closable="false" :footer="null"
            :pagination="false">
            <div class="ftr-1 cl-black">
                <div class="cl-info">
                    {{ $t('resolved.solutionInfo') }}
                </div>
                <div class="mt-4">
                    {{ $t('resolved.selectSolution') }}
                </div>
                <select class="form-select mt-3" v-model="result">
                    <option value="">{{ $t('resolved.pleaseSelect') }}</option>
                    <!-- <option value="0">{{ $t('resolved.none') }}</option> -->
                    <option value="1">{{ $t('resolved.courseCompleted') }}</option>
                    <option value="2">{{ $t('resolved.returnOnce') }}</option>
                    <option value="3">{{ $t('resolved.partialRefund') }}</option>
                </select>
                <div class="mt-4" v-if="result === '3'">
                    {{ $t('resolved.fillRefundAmount') }}
                </div>
                <a-input class="mt-2" v-model="money" :placeholder="$t('common.enter')" v-if="result === '3'"></a-input>
                <div class="cl-info mt-4">
                    {{ $t('resolved.feeInfo') }}
                </div>
                
                <div class="mt-4 d-flex justify-content-center">
                    <button type="button" class="btn btn-outline-gray px-4" @click="handleCancel"> {{ $t('resolved.cancel') }} </button>
                    <button type="button" class="btn btn-theme ml16 px-4" @click="disposeException">{{ $t('resolved.confirm') }}</button>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        order_id: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            result: '', // 老师给定方案:0=无,1=课程已完成,2=退回一次,3=部分退款
            money: ''
        }
    },
    created() {

    },
    methods: {
        handleCancel() {
            this.$emit('cancel')
        },
        // 处理异常
        disposeException() {
            this.$confirm({
                title: this.$t('resolved.confirmResolve'),
                content: this.$t('resolved.resolveText'),
                okText: this.$t('resolved.confirm'),
                okType: "danger",
                cancelText: this.$t('resolved.cancel'),
				okButtonProps: {
				    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
				  },
                onOk: () => {
                    this.$http.api('teacher/reservation/disposeException', {
                        order_id: this.order_id,
                        result: this.result,
                        money: this.money
                    }).then(res => {
                        this.$message.success(this.$t('resolved.operationSuccess'), 1, () => {
                            this.$emit('confirm')
                        })
                    })
                },
                onCancel: () => {
                    console.log("Cancel");
                },
            });
        },
    }
}
</script>

<style>
</style>